import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '../../i18n/uiText';

export default function HeaderMenu({ isOpen, onSelectChapter, onShowHistory, onShowBookmarks, onOpenSearch, onOpenChat, onGoSettings, onClose, showSearchAndChat = true }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleSelectChapter = () => {
    if (onSelectChapter) onSelectChapter();
  };

  const handleShowHistory = () => {
    if (onShowHistory) onShowHistory();
  };

  const handleShowBookmarks = () => {
    if (onShowBookmarks) onShowBookmarks();
  };

  const handleOpenSearch = () => {
    if (onOpenSearch) onOpenSearch();
  };

  const handleGoSettings = () => {
    if (onGoSettings) {
      onGoSettings();
    } else {
      navigate('/settings');
    }
  };

  const handleOpenChat = () => {
    if (onOpenChat) {
      onOpenChat();
    }
  };

  if (!isOpen) return null;

  const iconProps = {
    className: 'header-menu-item-icon',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.75,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    viewBox: '0 0 24 24',
    'aria-hidden': true,
  };

  return (
    <div
      className="header-menu-content"
      role="menu"
      aria-label={t('menu')}
      onClick={(e) => e.stopPropagation()}
    >
      {showSearchAndChat && onOpenSearch && (
        <button type="button" onClick={handleOpenSearch} className="header-menu-item" role="menuitem">
          <svg {...iconProps}>
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.35-4.35" />
          </svg>
          <span className="header-menu-item-label">{t('search')}</span>
          <span className="header-menu-item-chevron" aria-hidden>
            ›
          </span>
        </button>
      )}
      {showSearchAndChat && onOpenChat && (
        <button type="button" onClick={handleOpenChat} className="header-menu-item" role="menuitem">
          <svg {...iconProps}>
            <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" />
          </svg>
          <span className="header-menu-item-label">{t('chatActionLabel')}</span>
          <span className="header-menu-item-chevron" aria-hidden>
            ›
          </span>
        </button>
      )}

      {showSearchAndChat && <div className="header-menu-divider" role="separator" aria-hidden />}
      <button type="button" onClick={handleShowHistory} className="header-menu-item" role="menuitem">
        <svg {...iconProps}>
          <circle cx="12" cy="12" r="9" />
          <polyline points="12 7 12 12 15 14" />
        </svg>
        <span className="header-menu-item-label">{t('history')}</span>
        <span className="header-menu-item-chevron" aria-hidden>
          ›
        </span>
      </button>
      <button type="button" onClick={handleShowBookmarks} className="header-menu-item" role="menuitem">
        <svg {...iconProps}>
          <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
        </svg>
        <span className="header-menu-item-label">{t('savedTitle')}</span>
        <span className="header-menu-item-chevron" aria-hidden>
          ›
        </span>
      </button>
      <button type="button" onClick={handleGoSettings} className="header-menu-item" role="menuitem">
        <svg {...iconProps}>
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>
        <span className="header-menu-item-label">{t('settings')}</span>
        <span className="header-menu-item-chevron" aria-hidden>
          ›
        </span>
      </button>
    </div>
  );
}

